module.exports = __webpack_public_path__ + "img/icon-workforce.0368458c.svg";